import { createGlobalStyle } from 'styled-components';

// Define theme interface
export interface Theme {
  colors: {
    darkest: string;
    dark: string;
    medium: string;
    light: string;
    theme: string;
    accent: string;
  };
  shadows: {
    main: string;
  };
  breakpoints: {
    tablet: string;
    mobile: string;
  };
}

// Create theme object
export const theme: Theme = {
  colors: {
    darkest: '#333333',
    dark: '#f8f8f8',
    medium: '#e0e0e0',
    light: '#ffffff',
    theme: '#d4af37', // Gold color
    accent: '#c0c0c0', // Silver color
  },
  shadows: {
    main: '0 0.8rem 2.4rem rgba(0, 0, 0, 0.05)',
  },
  breakpoints: {
    tablet: '768px',
    mobile: '576px',
  },
};

const GlobalStyles = createGlobalStyle`
  :root {
    --color-darkest: #333333;
    --color-dark: #f8f8f8;
    --color-medium: #e0e0e0;
    --color-light: #ffffff;
    --color-theme: #d4af37; /* Gold color */
    --color-accent: #c0c0c0; /* Silver color */

    --shadow: 0 0.8rem 2.4rem rgba(0, 0, 0, 0.05);
    --font-primary: 'Cormorant Garamond', serif;
    --font-secondary: 'Montserrat', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    font-family: var(--font-secondary), -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  }

  /* Import elegant fonts */
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&family=Montserrat:wght@300;400;500;600;700&display=swap');

  body {
    min-height: 100vh;
    color: var(--color-darkest);
    background-color: var(--color-light);
    background-image: linear-gradient(to bottom right, #ffffff, #f8f8f8);
  }

  @media (max-width: 768px) {
    html {
      font-size: 56.25%;
    }
  }

  @media (max-width: 576px) {
    html {
      font-size: 50%;
    }
  }
`;

export default GlobalStyles;
